import React from 'react';
import { useNavigate } from 'react-router-dom';
import Seo from 'src/components/Seo';
import seoConfig from '../seo.json';
import Container from 'src/components/shared/Container';
import { Img } from 'react-image';
import { useAllTimeLeaderboard, useGetContests } from 'src/hooks/contest';
import UpcomingContestCard from 'src/components/contest/UpcomingContestCard';
import PastContestCard from 'src/components/contest/PastContestCard';
import ContestLeaderboardUI from 'src/components/contest/ContestLeaderboardUI';
import { Spinner } from 'flowbite-react';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';

const Contests = () => {
	const navigate = useNavigate();
	const seoInfo = seoConfig['contests'];

	const { data, isLoading } = useGetContests();
	const { data: allTimeLeaderboard, isLoading: isAllTimeLoading } = useAllTimeLeaderboard();

	return (
		<div>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<Container className="w-[92%] max-w-[1280px] pt-2  md:pb-2 pb-10 sm:w-[96%]font-inter">
				<div className="md:mt-[10px] flex font-inter items-end justify-between border-b border-solid border-[#C7C9D9] dark:border-[#555770] pb-[10px] sm:flex-col sm:items-start">
					<div>
						<div className="sm:hidden">{/* <MyApplicationsBreadcrumbs /> */}</div>
						<div className="mt-2 text-2xl font-inter font-bold dark:text-[#CDF] text-[#1F3343] flex">
							<span
								onClick={() => {
									// navigate('/dashboard');
									navigate('/my-applications');
								}}
								className="mr-3 inline-block align-bottom md:hidden my-auto"
							>
								<Img loading="lazy" src="/assets/arrowLeft.svg" alt="arrowLeft" width="24" height="24" />
							</span>
							Contests
						</div>
					</div>
				</div>

				{isLoading ? (
					<div className="flex justify-center pt-[30px]">
						{/* <Spinner /> */}
						<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
					</div>
				) : data?.liveContests?.length || data?.upComingContests?.length || data?.pastContests?.length ? (
					<div className="flex flex-col md:flex-row gap-[44px] mt-6">
						<div className="w-full md:max-w-[calc(100%-348px)] space-y-[36px]">
							{data?.liveContests?.length ? (
								<div>
									<div className="text-base font-medium dark:text-[#CDF] text-[#1F3343] mb-[10px]">Live</div>
									{/* Upcoming Contest cards */}
									<div className="space-y-3">
										{data?.liveContests?.map(contest => <UpcomingContestCard key={contest._id} contest={contest} />)}
									</div>
								</div>
							) : null}
							{data?.upComingContests?.length ? (
								<div>
									<div className="text-base font-medium dark:text-[#CDF] text-[#1F3343] mb-[10px]">Upcoming</div>
									{/* Upcoming Contest cards */}
									<div className="space-y-3">
										{data?.upComingContests?.map(contest => (
											<UpcomingContestCard key={contest._id} contest={contest} />
										))}
									</div>
								</div>
							) : null}
							{data?.pastContests?.length ? (
								<div>
									<div className="text-base font-medium dark:text-[#CDF] text-[#1F3343]">Past Contests</div>
									{/* Past Contest cards */}
									<div className="mt-[10px] flex flex-row md:flex-col gap-[10px] tmd:gap-5 overflow-auto -mx-4 px-4">
										{data?.pastContests?.map(contest => <PastContestCard key={contest._id} contest={contest} />)}
									</div>
								</div>
							) : null}
						</div>
						<div className="w-full md:max-w-[348px]">
							{isAllTimeLoading ? (
								<div className="flex justify-center pt-[30px]">
									{/* <Spinner /> */}
									<NewCreatingPositionLoader
										showAnimation={true}
										progressBar={false}
										customClassCss="!w-[70%] mx-auto "
									/>
								</div>
							) : null}
							{!isAllTimeLoading && (allTimeLeaderboard?.leaderboard?.length || 0) >= 8 ? (
								<div className="sticky top-[80px]">
									<div className="mt-2 text-xl font-inter font-bold dark:text-[#CDF] text-[#1F3343] flex">
										All time Leaderboard
									</div>

									<div className="mt-[8px]">
										<ContestLeaderboardUI
											leaderboard={allTimeLeaderboard?.leaderboard || []}
											userRankData={allTimeLeaderboard?.userRankData}
										/>
									</div>
								</div>
							) : null}
						</div>
					</div>
				) : (
					<div className="flex justify-center items-center flex-col text-center mt-[80px]">
						<Img src={'/assets/contestEmptyState.svg'} />
						<h3 className="text-gray-800 text-2xl font-[500] mt-4">Stay tuned for exciting coding contests!</h3>
						<p className="text-gray-500 max-w-[415px] mt-2">
							There are currently no coding contests available, but keep an eye out for upcoming challenges.
						</p>
					</div>
				)}
			</Container>
		</div>
	);
};

export default Contests;
